export default "__VITE_ASSET__0c5c24e0__"